/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum SubjectRequestType {
    ForGroups = 'ForGroups',
    ForSubgroupsAdd = 'ForSubgroupsAdd',
    ForSubgroupsEdit = 'ForSubgroupsEdit'
}

export function SubjectRequestTypeFromJSON(json: any): SubjectRequestType {
    return SubjectRequestTypeFromJSONTyped(json, false);
}

export function SubjectRequestTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubjectRequestType {
    return json as SubjectRequestType;
}

export function SubjectRequestTypeToJSON(value?: SubjectRequestType | null): any {
    return value as any;
}

